import { fulfillmentTransactionIsValid } from "services/sosInventoryService/fulfillmentTransaction/isValid";
import { quantitySerialsIsValid } from "services/utility/isValid";

import globalState from "globalState/globalState";

export function isValid(record, relatedRecords, lines) {
  const { showPickTicketSerialsLots } =
    globalState.getState().userCompanySettings.settings;

  let errors = fulfillmentTransactionIsValid(record, relatedRecords, lines);

  // only validate on serials if "showPickTicketSerialsLots" enabled
  if (showPickTicketSerialsLots) {
    errors = quantitySerialsIsValid(errors, lines);
  }
  return errors;
}
